export const DECISION_TYPES =
  Object.freeze({
    MITIGATE: "MITIGATE",
    TRANSFER: "TRANSFER",
    RETAIN: "RETAIN",
    ACCEPT: "ACCEPT",
    AVOID: "AVOID",
    MONITOR: "MONITOR",

    REALLOCATE_CAPITAL:
      "REALLOCATE_CAPITAL",

    RENEW_COVERAGE:
      "RENEW_COVERAGE",

    MODIFY_COVERAGE:
      "MODIFY_COVERAGE",
  });


export const DECISION_SCOPES =
  Object.freeze({
    SCENARIO: "SCENARIO",
    PORTFOLIO: "PORTFOLIO",
    FINANCING: "FINANCING",
    GOVERNANCE: "GOVERNANCE",
  });


  export const DECISION_PRIORITIES =
  Object.freeze({
    UNSET: "UNSET",
    CRITICAL: "CRITICAL",
    HIGH: "HIGH",
    MEDIUM: "MEDIUM",
    LOW: "LOW",
  });


export const DECISION_ENGINES =
  Object.freeze({
    SCENARIO:
      "scenario_decision_engine",

    PORTFOLIO:
      "portfolio_decision_engine",

    RISK_FINANCING:
      "risk_financing_engine",

    COVERAGE:
      "coverage_engine",
  });

function normalizeDecisionPriority(
    priority
  ) {

    if (!priority) {
      return {
        score: 0,
        level:
          DECISION_PRIORITIES.UNSET,
        rank: null,
        rationale: null,
      };
    }


    if (
      typeof priority === "string"
    ) {
      const normalizedLevel =
        String(priority)
          .trim()
          .toUpperCase();

      return {
        score: 0,
        level:
          DECISION_PRIORITIES[
            normalizedLevel
          ] ||
          DECISION_PRIORITIES.UNSET,
        rank: null,
        rationale: null,
      };
    }


    const normalizedLevel =
      String(
        priority?.level || ""
      )
        .trim()
        .toUpperCase();


    const numericScore =
      Number(
        priority?.score
      );


    const numericRank =
      Number(
        priority?.rank
      );


    return {
      score:
        Number.isFinite(
          numericScore
        )
          ? numericScore
          : 0,

      level:
        DECISION_PRIORITIES[
          normalizedLevel
        ] ||
        DECISION_PRIORITIES.UNSET,

      rank:
        Number.isFinite(
          numericRank
        )
          ? numericRank
          : null,

      rationale:
        priority?.rationale ||
        null,
    };
  }


  export function createDecisionRecommendation({
    id = null,
    source = null,
    engine = null,
    scope = null,

    decisionType = null,

    title = null,
    strategy = null,

    rationale = null,

    priority = null,

    financialImpact = null,

    evidence = null,

    metadata = null,

  } = {}) {

    return {

      id,

      source,

      engine,

      scope,

      decisionType,

      title,

      strategy,

      rationale,

      priority:
        normalizeDecisionPriority(
          priority
        ),

      financialImpact,

      evidence,

      metadata,

    };
  }
